/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "noTranslations": true,
  "name": "Customizable new sprite position",
  "description": "Change the default x/y position of new sprites.",
  "credits": [
    {
      "name": "pufferfish101007",
      "link": "https://scratch.mit.edu/users/pufferfish101007/"
    }
  ],
  "dynamicDisable": true,
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "settings": [
    {
      "dynamic": true,
      "id": "x",
      "name": "X position",
      "type": "integer",
      "default": 0,
      "min": -240,
      "max": 240
    },
    {
      "dynamic": true,
      "id": "y",
      "name": "Y position",
      "type": "integer",
      "default": 0,
      "min": -180,
      "max": 180
    },
    {
      "dynamic": true,
      "id": "library",
      "name": "Randomize the position of library sprites",
      "type": "boolean",
      "default": false
    },
    {
      "dynamic": true,
      "id": "duplicate",
      "name": "Behavior when duplicating sprites",
      "type": "select",
      "default": "randomize",
      "potentialValues": [
        {
          "id": "custom",
          "name": "Send to specified x/y values"
        },
        {
          "id": "keep",
          "name": "Keep the same as the original sprite"
        },
        {
          "id": "randomize",
          "name": "Randomize"
        }
      ]
    }
  ],
  "tags": [],
  "enabledByDefault": false
};
export default manifest;
